function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProgramSelectApi, getProgramTaskApi, getProgramVersionSelectApi, getProgramTaskSelectApi, getProgramMemberApi, putProgramTaskBatchApi, deleteProgramTaskBatchApi, putProgramTaskApi, putTaskSortApi, saveSubordinateApi } from '@/api/program';
import SettingMer from '@/libs/settingMer';
import editTask from './components/editTask';
import Sortable from 'sortablejs';
import ClipboardJS from 'clipboard';
export default {
  name: 'programTask',
  components: {
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    },
    addTask: function addTask() {
      return import('./components/addTask');
    },
    editTask: editTask
  },
  props: {
    programId: {
      type: Number,
      default: 0
    },
    isDrawer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tableData: [],
      showDiv: false,
      divStyle: {
        position: 'absolute',
        padding: '10px 5px',
        display: 'none',
        // 初始不显示
        left: '0',
        top: '0',
        background: '#f5f6f8',
        opacity: '0.8'
      },
      loading: false,
      activeIds: [],
      childrenLevel: 1,
      childrenOldPid: 0,
      startShowStates: {},
      endShowStates: {},
      membersShowStates: {},
      adminsShowStates: {},
      versionId: '',
      adminsUid: null,
      tableFrom: {
        page: 1,
        limit: 15,
        types: 0,
        name: '',
        pid: 0,
        program_id: this.programId || '',
        version_id: [],
        time_field: '',
        time: '',
        status: [],
        priority: [],
        scope_frame: 'all',
        scope_normal: 0,
        members: [],
        admins: []
      },
      total: 0,
      addName: '',
      parentId: 0,
      addRow: {},
      projectList: [],
      programVersionList: [],
      programOptions: [],
      programMemberOptions: [],
      headerShow: false,
      ids: [],
      checkedId: [],
      formData: {
        data: [],
        program_id: this.programId || null
      },
      memberShow: false,
      versionVisible: {},
      adminsVisible: {},
      membersVisible: {},
      userList: [],
      onlyOne: false,
      btnShow: false,
      priorityShow: false,
      selectData: {
        priorityOptions: [{
          value: 1,
          label: '紧急'
        }, {
          value: 2,
          label: '高'
        }, {
          value: 3,
          label: '中'
        }, {
          value: 4,
          label: '低'
        }, {
          value: 0,
          label: '无优先级'
        }],
        statusOptions: [{
          value: 0,
          label: '未处理'
        }, {
          value: 1,
          label: '进行中'
        }, {
          value: 2,
          label: '已解决'
        }, {
          value: 3,
          label: '已验收'
        }, {
          value: 4,
          label: '已拒绝'
        }, {
          value: 5,
          label: '已关闭'
        }]
      },
      iconVisible: {},
      preventBlur: false,
      membersId: [],
      row: {},
      adminIndex: '',
      versionIndex: '',
      membersIndex: '',
      parentRoleId: '',
      currentRoleId: '',
      maps: new Map(),
      rowDown: {},
      rowUp: {},
      activeAdd: false,
      activeEdit: false,
      dragging: false,
      startX: 0,
      startY: 0,
      hoveredRow: null,
      // 用于追踪悬停的行索引
      sortableFix: undefined,
      sortable: undefined,
      activeRows: [],
      treeData: [{
        options: [{
          value: 0,
          label: '全部任务'
        }, {
          value: 1,
          label: '我负责的'
        }, {
          value: 2,
          label: '我参与的'
        }, {
          value: 3,
          label: '我创建的'
        }]
      }],
      search: [{
        field_name: '任务名称',
        field_name_en: 'name',
        form_value: 'input'
      }, {
        field_name: '优先级',
        field_name_en: 'priority',
        form_value: 'checkbox',
        props: {
          collapseTags: true
        },
        data_dict: [{
          value: 1,
          label: '紧急'
        }, {
          value: 2,
          label: '高'
        }, {
          value: 3,
          label: '中'
        }, {
          value: 4,
          label: '低'
        }, {
          value: 0,
          label: '无优先级'
        }]
      }, {
        field_name: '状态',
        field_name_en: 'status',
        form_value: 'checkbox',
        props: {
          collapseTags: true
        },
        data_dict: [{
          value: 0,
          name: '未处理'
        }, {
          value: 1,
          name: '进行中'
        }, {
          value: 2,
          name: '已解决'
        }, {
          value: 3,
          name: '已验收'
        }, {
          value: 4,
          name: '已拒绝'
        }, {
          value: 5,
          name: '已关闭'
        }]
      }, {
        field_name: '项目',
        field_name_en: 'program_id',
        form_value: 'select',
        data_dict: []
      }, {
        field_name: '版本',
        field_name_en: 'version_id',
        form_value: 'checkbox',
        props: {
          collapseTags: true
        },
        data_dict: []
      }],
      viewSearch: [{
        title: '负责人',
        field: 'user_id'
      }, {
        title: '协作者',
        field: 'update_user_id'
      }, {
        title: '计划开始',
        field: 'plan_start',
        type: 'date_picker'
      }, {
        title: '计划结束',
        field: 'plan_end',
        type: 'date_picker'
      }, {
        title: '创建时间',
        field: 'created_at',
        type: 'date_picker'
      }],
      dropdownList: [{
        label: '批量操作',
        value: 1
      }],
      treeDefault: 0
    };
  },
  computed: {
    treePaddingClass: function treePaddingClass() {
      return this.headerShow ? 'header-show-padding' : 'normal-padding';
    }
  },
  watch: {
    programId: function programId(newVal) {
      this.$set(this.tableFrom, 'program_id', newVal);
      this.$set(this.formData, 'program_id', newVal);
      this.getProgramMember(newVal);
      this.programId = newVal;
      this.getTableData();
      this.getProgramVersion(newVal);
    },
    // 监听 program_id 变化 选择项目自动获取版本
    'tableFrom.program_id': function tableFromProgram_id(val) {
      this.getProgramVersion(val);
    }
  },
  created: function created() {
    this.tableFrom.program_id = this.programId ? this.programId : '';
    this.getProgram();
    // 判断是否为抽屉模式 不需要项目搜索框
    if (this.isDrawer && this.programId !== 0) {
      // 然后，从 this.search 中移除 field_name_en 为 'program_id' 的对象
      this.search = this.search.filter(function (item) {
        return item.field_name_en !== 'program_id';
      });
      this.getTableData();
    }
    // 判断是否为抽屉模式 不是
    if (!this.isDrawer) {
      this.getTableData();
    }
    // 监听 program_id 变化 选择项目自动获取版本
    if (this.programId) {
      this.getProgramVersion(this.programId);
      this.getProgramMember(this.programId);
      var row = {
        program_id: this.programId
      };
      this.getProgramSelect(row);
    } else {
      this.getProgramVersion('');
    }
  },
  methods: {
    //结束时间不能小于开始时间
    disabledEndDate: function disabledEndDate(time) {
      return time.getTime() < new Date(this.formData.start_date).getTime() - 8.64e7;
    },
    setSort: function setSort() {
      var _this = this;
      // ref一定跟table上面的ref一致
      var el = this.$refs.tableData.$el.querySelector('.el-table__fixed-body-wrapper tbody');
      var el2 = this.$refs.tableData.$el.querySelector('.el-table__body-wrapper tbody');
      //设置拖拽的参数
      var ops = {
        animation: 200,
        //动画时长
        ghostClass: 'sortable-ghost',
        handle: '.handle',
        //拖拽中事件监听
        onMove: function onMove(_ref) {
          var dragged = _ref.dragged,
            related = _ref.related;
        },
        //拖拽后事件监听
        onEnd: function onEnd(evt) {
          // 把树形的结构转为列表再进行拖拽
          var rowDown = _this.activeRows[evt.oldIndex]; // 移动的那个元素
          var rowUp = _this.activeRows[evt.newIndex]; // 移动的那个元素
          if (rowDown.pid !== rowUp.pid) {
            var tagName = evt.item.tagName;
            var items = evt.from.getElementsByTagName(tagName);
            if (evt.oldIndex > evt.newIndex) {
              evt.from.insertBefore(evt.item, items[evt.oldIndex + 1]);
            } else {
              evt.from.insertBefore(evt.item, items[evt.oldIndex]);
            }
            return _this.$message.warning('不允许跨级拖动!');
          }
          // 拖动一级
          if (rowDown.pid === 0) {
            _this.tableData.map(function (item) {
              _this.activeIds.push(item.id);
            });
          } else if (rowDown.pid == rowUp.pid) {
            // 拖动子级
            _this.tableData.map(function (item) {
              if (item.id == rowDown.pid) {
                item.children.map(function (it) {
                  _this.activeIds.push(it.id);
                });
              }
            });
          }
          _this.moveElementAfter(_this.activeIds, rowDown.id, rowUp.id);
        }
      };
      this.sortableFix = Sortable.create(el, ops);
      this.sortable = Sortable.create(el2, ops);
    },
    elChangeExForArray: function elChangeExForArray(index1, index2, array, init) {
      var _this2 = this;
      var arr = array;
      var temp = array[index1];
      var tempt = array[index2];
      if (init) {
        arr[index2] = tempt;
        arr[index1] = temp;
      } else {
        arr[index1] = tempt;
        arr[index2] = temp;
      }
      this.tableData = [];
      this.$nextTick(function (e) {
        _this2.tableData = arr;
      });
    },
    // 树形结构扁平化
    flattenTreeData: function flattenTreeData(treeData) {
      var result = [];
      function flatten(node) {
        result.push(node);
        if (node.children && node.children.length > 0) {
          node.children.forEach(function (child) {
            return flatten(child);
          });
        }
      }
      treeData.forEach(function (node) {
        return flatten(node);
      });
      return result;
    },
    // 鼠标进入表格行的回调函数
    handleMouseEnter: function handleMouseEnter(row, column, cell, event) {
      var data = this.flattenTreeData(this.tableData);
      var rowIndex = data.indexOf(row);
      this.hoveredRow = rowIndex;
    },
    /**
     * 处理鼠标离开事件
     *
     * @returns 无返回值
     */
    handleMouseLeave: function handleMouseLeave() {
      this.hoveredRow = null;
    },
    /**
     * 将指定元素移动到另一个元素后
     *
     * @param data 数据数组
     * @param startId 起始元素ID
     * @param endId 目标元素ID
     * @returns 无返回值
     */
    moveElementAfter: function moveElementAfter(data, startId, endId) {
      var _this3 = this;
      var startIndex = data.indexOf(startId);
      var endIndex = data.indexOf(endId);
      if (startIndex === -1 || endIndex === -1) {
        return;
      }
      var _data$splice = data.splice(startIndex, 1),
        _data$splice2 = _slicedToArray(_data$splice, 1),
        item = _data$splice2[0];
      var newEndIndex = endIndex - (startIndex < endIndex ? 1 : 0);
      var datas = {
        current: startId,
        target: endId
      };
      putTaskSortApi(datas).then(function () {
        _this3.tableFrom.pid = 0;
        _this3.getTableData();
        _this3.activeRows = [];
        _this3.activeIds = [];
        _this3.tableData = [];
      });
    },
    /**
     * 处理鼠标按下事件
     *
     * @param row 按下所在的行数据
     * @param event 鼠标按下事件对象
     */
    handleMouseDown: function handleMouseDown(row, event) {
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.dragging = false; // 初始化拖拽标志
      this.rowDown = row;
      this.updateDivPosition(event.pageX, event.pageY);
      // 添加移动事件监听
      document.addEventListener('mousemove', this.handleMouseMove);
    },
    /**
     * 处理鼠标移动事件
     *
     * @param event 鼠标移动事件对象
     * @returns 无返回值
     */
    handleMouseMove: function handleMouseMove(event) {
      var moveX = event.clientX - this.startX;
      var moveY = event.clientY - this.startY;
      if (Math.abs(moveX) > 5 || Math.abs(moveY) > 5) {
        // 仅当移动超过5像素时认为是拖拽
        this.dragging = true;
        this.showDiv = true;
      } else {
        this.dragging = false;
        this.showDiv = false;
      }
      this.updateDivPosition(event.pageX, event.pageY);
    },
    /**
     * 处理鼠标松开事件
     *
     * @param row 当前的行数据
     * @param event 鼠标事件对象
     * @returns 如果拖动的行ID相同，返回false；如果跨级拖动，返回警告提示；否则返回undefined
     */
    handleMouseUp: function handleMouseUp(row, event) {
      var _this4 = this;
      this.showDiv = false;
      this.dragging = false;
      document.removeEventListener('mousemove', this.handleMouseMove);
      this.rowUp = row;
      if (this.rowDown.id == this.rowUp.id) {
        return false;
      }
      if (this.rowDown.pid !== this.rowUp.pid) {
        return this.$message.warning('不允许跨级拖动!');
      }
      // 拖动一级
      if (this.rowDown.pid === 0) {
        this.tableData.map(function (item) {
          _this4.activeIds.push(item.id);
        });
      } else if (this.rowDown.pid == this.rowUp.pid) {
        // 拖动子级
        this.tableData.map(function (item) {
          if (item.id == _this4.rowDown.pid) {
            item.children.map(function (it) {
              _this4.activeIds.push(it.id);
            });
          }
        });
      }
      this.moveElementAfter(this.activeIds, this.rowDown.id, this.rowUp.id);
    },
    /**
     * 鼠标离开事件处理函数
     *
     * @description 当鼠标离开时，将显示 div 的变量 showDiv 设置为 false，并将 div 的 display 样式设置为 'none'
     */
    mouseLeave: function mouseLeave() {
      this.showDiv = false;
      this.divStyle.display = 'none';
    },
    /**
     * 更新 div 的位置
     *
     * @param x 横向位置
     * @param y 纵向位置
     * @returns 无返回值
     */
    updateDivPosition: function updateDivPosition(x, y) {
      var offsetX = -260; // 调整横向位置
      var offsetY = -200; // 调整纵向位置
      this.divStyle.left = x + offsetX + 'px';
      this.divStyle.top = y + offsetY + 'px';
      if (!this.showDiv) {
        // 只有在 showDiv 为 false 时才设置为显示状态
        this.divStyle.display = 'block';
      }
    },
    /**
     * 复制文本到剪贴板
     *
     * @returns 无返回值
     */
    copy: function copy() {
      var _this5 = this;
      this.$nextTick(function () {
        var clipboard = new ClipboardJS('.copy');
        clipboard.on('success', function () {
          _this5.$message.success(_this5.$t('setting.copytitle'));
          clipboard.destroy();
        });
        clipboard.on('error', function () {});
        clipboard.onClick(event);
        _this5.$store.commit('app/SET_CLICK_TAB', false);
      });
    },
    // 复制工作项地址
    identAddress: function identAddress(row) {
      var type = 'type',
        relation_id = 'relation_id',
        program_id = 'program_id';
      return "".concat(SettingMer.httpUrl).concat(window.location.pathname).concat(window.location.search, "?&").concat(type, "=2&").concat(relation_id, "=").concat(row.id, "&").concat(program_id, "=").concat(row.program_id);
    },
    // 获取表格数据
    getTableData: function getTableData(tableFrom) {
      var _this6 = this;
      if (tableFrom) {
        this.tableFrom.page = tableFrom.page;
      }
      this.loading = true;
      var data = tableFrom ? tableFrom : this.tableFrom;
      data.program_id = this.programId || this.tableFrom.program_id;
      // 懒加载刷新新父级
      if (!this.parentRoleId) {
        data.pid = 0;
        getProgramTaskApi(data).then(function (res) {
          _this6.tableData = res.data.list;
          _this6.activeRows = _this6.treeToTile(res.data.list);
          if (data.pid) {
            _this6.tableChildrenData = res.data.list;
          }
          _this6.total = res.data.count;
          _this6.loading = false;
          _this6.$nextTick(function (e) {
            _this6.setSort();
          });
        }).catch(function (error) {
          _this6.loading = false;
        });
      }
      if (this.parentRoleId && this.maps.get(this.parentRoleId)) {
        this.loading = false;
        var _this$maps$get = this.maps.get(this.parentRoleId),
          tree = _this$maps$get.tree,
          treeNode = _this$maps$get.treeNode,
          resolve = _this$maps$get.resolve;
        this.load(tree, treeNode, resolve);
      }
      //懒加载刷新当前级
      if (this.currentRoleId && this.maps.get(this.currentRoleId)) {
        this.loading = false;
        var _this$maps$get2 = this.maps.get(this.currentRoleId),
          _tree = _this$maps$get2.tree,
          _treeNode = _this$maps$get2.treeNode,
          _resolve = _this$maps$get2.resolve;
        this.load(_tree, _treeNode, _resolve);
      }
    },
    /**
     * 将树形数据转换为平铺数组
     *
     * @param treeData 树形数据
     * @param childKey 子节点键名，默认为 'children'
     * @returns 平铺后的数组
     */
    treeToTile: function treeToTile(treeData) {
      var childKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
      var arr = [];
      var _expanded = function expanded(data) {
        if (data && data.length > 0) {
          data.filter(function (d) {
            return d;
          }).forEach(function (e) {
            arr.push(e);
            _expanded(e[childKey] || []);
          });
        }
      };
      _expanded(treeData);
      return arr;
    },
    /**
     * 添加任务
     *
     * @returns 无返回值
     */
    addProgram: function addProgram() {
      this.getProgram();
      if (this.programId) {
        this.formData.program_id = Number(this.programId);
        this.formData.pid = 0;
        var data = {
          program_id: Number(this.programId),
          pid: 0,
          describe: ''
        };
        this.$refs.addTask.openBox(0, data);
      } else {
        this.$refs.addTask.reset();
        this.$refs.addTask.drawer = true;
      }
    },
    /**
     * 添加按钮后面更多下拉框选项点击事件处理函数
     *
     * @param item 下拉框选项对象
     * @returns 无返回值
     */
    dropdownFn: function dropdownFn(item) {
      switch (item.value) {
        case 1:
          this.batchOperation();
          break;
      }
    },
    /**
     * 打开任务
     *
     * @param data 任务数据
     * @param type 任务类型，1为项目任务，0为其他任务
     */
    openTask: function openTask(data, type) {
      var id = type == 1 ? data.pid : 0;
      this.$refs.addTask.openBox(id, data);
      this.$refs.editTask.drawer = false;
    },
    // 获取项目成员下拉列表
    getProgramMember: function getProgramMember(program_id, index, type) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getProgramMemberApi({
                program_id: program_id
              });
            case 2:
              result = _context.sent;
              _this7.programMemberOptions = result.data;
              if (_this7.programMemberOptions.length) {
                if (type == 1) {
                  _this7.$set(_this7.adminsVisible, index, true);
                }
                if (type == 2) {
                  _this7.$set(_this7.membersVisible, index, true);
                }
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * 获取选择项目的任务列表
     *
     * @param row 行数据
     * @returns 无返回值
     */
    getProgramSelectList: function getProgramSelectList(row) {
      this.getProgramSelect(row);
    },
    // 获取父级任务下拉列表
    getProgramSelect: function getProgramSelect(row) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                program_id: row.program_id
              };
              _context2.next = 3;
              return getProgramTaskSelectApi(data);
            case 3:
              result = _context2.sent;
              result.data.map(function (item) {
                if (row.id === item.value) {
                  _this8.$set(item, 'disabled', true);
                }
              });
              _this8.programOptions = result.data;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 获取项目数据
    getProgram: function getProgram() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getProgramSelectApi();
            case 2:
              result = _context3.sent;
              _this9.projectList = result.data;
              _this9.setDataDict('program_id', result.data);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    /**
     * 获取成员列表
     *
     * @param program_id 节目ID
     * @returns 无返回值
     */
    getMemberList: function getMemberList(program_id) {
      this.getProgramMember(program_id);
    },
    /**
     * 获取项目版本列表
     *
     * @param program_id 程序ID
     * @returns 无返回值，通过调用 this.getProgramVersion(program_id) 获取程序版本信息
     */
    getProgramVersionList: function getProgramVersionList(program_id) {
      this.getProgramVersion(program_id);
    },
    // 获取项目版本数据
    getProgramVersion: function getProgramVersion(program_id, index, type) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getProgramVersionSelectApi({
                program_id: program_id
              });
            case 2:
              result = _context4.sent;
              _this10.programVersionList = result.data;
              _this10.setDataDict('version_id', result.data);
              if (_this10.programVersionList.length) {
                _this10.$set(_this10.versionVisible, index, true);
              } else if (type == 1) {
                _this10.$message('请到任务详情设置版本');
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 编辑任务
    editProgram: function editProgram(row) {
      this.$refs.editTask.openBox(row.id);
      this.getProgramVersion(row.program_id);
      this.getMemberList(row.program_id);
      this.getProgramSelect(row);
    },
    // 批量操作
    batchOperation: function batchOperation() {
      this.headerShow = !this.headerShow;
    },
    /**
     * 处理列表复选框选择项变化事件
     *
     * @param val 选择项数组
     * @returns 无返回值
     */
    handleSelectionChange: function handleSelectionChange(val) {
      this.checkedId = val.map(function (item) {
        return item.id;
      });
      this.ids = val;
    },
    /**
     * 将表单数据中的 version_id、uid 和 path 设置为空字符串
     */
    setValueNull: function setValueNull() {
      this.formData.version_id = '';
      this.formData.uid = '';
      this.formData.path = '';
    },
    // 选择项目获取项目成员、版本、任务数据
    handleContract: function handleContract(eid) {
      var row = {
        program_id: eid
      };
      this.getProgramVersionList(eid);
      this.getMemberList(eid);
      this.getProgramSelectList(row);
    },
    handleRemove: function handleRemove(e) {
      this.formData.path = e;
      this.formData.pid = e[e.length - 1];
    },
    // 批量提交
    submitEvt: function submitEvt() {
      var _this11 = this;
      if (this.ids.length == 0) {
        return this.$message.error('请至少选择一项');
      }
      this.ids.forEach(function (item) {
        _this11.formData.data.push(item.id);
      });
      putProgramTaskBatchApi(this.formData).then(function (res) {
        _this11.headerShow = false;
        _this11.tableFrom.pid = '';
        _this11.getTableData();
        _this11.cancelEvt();
      });
    },
    // 批量删除
    deleteEvt: function deleteEvt() {
      var _this12 = this;
      if (this.ids.length == 0) {
        return this.$message.error('请至少选择一项');
      }
      this.ids.forEach(function (item) {
        _this12.formData.data.push(item.id);
      });
      this.$modalSure('删除任务，关联的子级任务均会被删除').then(function () {
        deleteProgramTaskBatchApi({
          data: _this12.formData.data
        }).then(function () {
          _this12.headerShow = false;
          _this12.tableFrom.pid = '';
          _this12.getTableData();
        });
      });
    },
    // 批量取消
    cancelEvt: function cancelEvt() {
      this.formData = {
        program_id: this.programId || null,
        version_id: null,
        uid: null,
        pid: null,
        path: [],
        plan_end: '',
        status: null,
        data: []
      };
      this.ids = [];
      this.userList = [];
      this.headerShow = false;
      this.$refs.tableData.clearSelection();
    },
    /**
     * 切换页码
     *
     * @param page 页码
     */
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getTableData();
    },
    /**
     * 处理表格每页显示条数改变的事件
     *
     * @param val 新的每页显示条数
     */
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getTableData();
    },
    /**
     * 表单搜索
     *
     * @param data 数据对象
     * @returns 无
     */
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.tableFrom = {
          page: 1,
          limit: 15,
          types: 0,
          name: '',
          pid: 0,
          program_id: this.programId || '',
          version_id: [],
          time_field: '',
          time: '',
          status: [],
          priority: [],
          scope_frame: 'all',
          scope_normal: 0,
          members: [],
          admins: []
        };
        this.getTableData();
      } else {
        if (data.user_id) {
          data.admins = data.user_id;
        }
        if (data.update_user_id) {
          data.members = data.update_user_id;
        }
        Object.keys(data).forEach(function (key) {
          if (key == 'user_id') {
            data.admins = data.user_id;
          }
          if (key == 'update_user_id') {
            data.members = data.update_user_id;
          }
          if (['plan_start', 'plan_end', 'created_at'].includes(key)) {
            data.time_field = key;
            data.time = data[key];
          }
        });
        this.tableFrom = _objectSpread(_objectSpread({}, this.tableFrom), data);
        this.tableFrom.page = 1;
        this.getTableData();
      }
    },
    /**
     * 选择关联版本
     *
     * @param id 版本ID
     * @param index 版本索引
     * @param type 版本类型
     * @returns Promise<void>
     */
    changeVersion: function changeVersion(id, index, type) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this13.versionIndex = index;
              _context5.next = 3;
              return _this13.getProgramVersion(id, index, type);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    /**
     * 修改时获取负责人
     *
     * @param id 节目ID
     * @param index 修改位置索引
     * @param type 管理员类型
     * @returns 无返回值，异步执行
     */
    changeAdmins: function changeAdmins(id, index, type) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this14.adminIndex = index;
              _context6.next = 3;
              return _this14.getProgramMember(id, index, type);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    /**
     * 更改获取协作者信息
     *
     * @param row 表格行数据
     * @param index 表格行索引
     * @param type 成员类型
     * @returns Promise
     */
    changeMembers: function changeMembers(row, index, type) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this15.row = row;
              _context7.next = 3;
              return _this15.getProgramMember(row.program_id, index, type);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    /**
     * 选择版本
     *
     * @param row 版本行数据
     * @param index 版本索引
     */
    chooseVersion: function chooseVersion(row, index) {
      this.putProgramTask('version_id', this.versionId, row.id);
      this.hideVersion(index);
    },
    /**
     * 选择负责任
     *
     * @param row 管理员对象
     * @param index 管理员列表索引
     */
    chooseAdmins: function chooseAdmins(row, index) {
      this.putProgramTask('uid', this.adminsUid, row.id);
      this.hideAdmins(index);
    },
    // 修改单个任务信息
    putProgramTask: function putProgramTask(field, data, id) {
      var _this16 = this;
      var datas = {};
      datas['field'] = field;
      datas[field] = data;
      if (field == 'pid') {
        datas['path'] = this.formData.path;
      }
      putProgramTaskApi(id, datas).then(function () {
        _this16.activeEdit = false;
        if (_this16.tableFrom.page) {
          _this16.getTableData(_this16.tableFrom);
        } else {
          _this16.getTableData();
        }
        _this16.$set(_this16.membersVisible, _this16.membersIndex, false);
      });
    },
    /**
     * 判断是否具有操作权限
     *
     * @param row 行数据对象
     * @returns 如果没有操作权限，则弹出提示信息；否则不返回任何值
     */
    isOperate: function isOperate(row) {
      if (!row.operate) {
        return this.$message('没有操作权限');
      }
    },
    /**
     * 处理开始点击事件
     *
     * @param row 表格行数据
     * @returns 无返回值
     */
    handleStartClick: function handleStartClick(row) {
      if (!row.operate) {
        return this.$message('没有操作权限');
      }
      this.$set(this.startShowStates, row.id, true);
    },
    /**
     * 隐藏开始时间选择器
     *
     * @param rowId 行ID
     * @returns 无返回值
     */
    hideStartPicker: function hideStartPicker(rowId) {
      this.$set(this.startShowStates, rowId, false);
    },
    /**
     * 处理结束按钮点击事件
     *
     * @param row 当前行数据
     * @returns 无返回值
     */
    handleEndClick: function handleEndClick(row) {
      if (!row.operate) {
        return this.$message('没有操作权限');
      }
      this.$set(this.endShowStates, row.id, true);
    },
    /**
     * 隐藏结束时间选择器
     *
     * @param rowId 行ID
     */
    hideEndPicker: function hideEndPicker(rowId) {
      this.$set(this.endShowStates, rowId, false);
    },
    /**
     * 隐藏成员选择器
     */
    hideMembersPicker: function hideMembersPicker() {
      if (this.membersVisible[this.membersIndex] == true && this.row.id) {
        this.putProgramTask('members', this.membersId, this.row.id);
      }
      this.$set(this.versionVisible, this.versionIndex, false);
      this.$set(this.adminsVisible, this.adminIndex, false);
      this.$set(this.membersVisible, this.membersIndex, false);
    },
    /**
     * 显示图标
     *
     * @param index 图标索引
     * @returns 无返回值
     */
    showIcon: function showIcon(index) {
      this.$set(this.iconVisible, index, true);
    },
    /**
     * 隐藏图标
     *
     * @param index 图标索引
     */
    hideIcon: function hideIcon(index) {
      this.$set(this.iconVisible, index, false);
    },
    /**
     * 添加子节点
     *
     * @param row 要添加子节点的行数据
     * @returns 如果当前处于添加状态，则返回false，否则返回undefined
     */
    addChild: function addChild(row) {
      var _this17 = this;
      if (this.activeAdd) {
        return false;
      }
      this.addRow = row;
      this.parentId = row.id;
      this.addName = '';
      var newRow = {
        id: Date.now(),
        pid: row.id,
        name: '',
        children: [],
        add: true
      };
      this.activeAdd = true;
      var _findAndAdd = function findAndAdd(array) {
        array.forEach(function (item) {
          if (item.id === row.id) {
            if (!item.children) {
              _this17.$set(item, 'children', []);
            }
            item.children.unshift(newRow);
            _this17.$set(item, 'has_children', true);
          } else if (item.children && item.children.length > 0) {
            _findAndAdd(item.children);
          }
        });
      };
      _findAndAdd(this.tableData);
    },
    // 回车提交
    handleEnter: function handleEnter(row, type) {
      var _this18 = this;
      if (type === 1) {
        this.preventBlur = true;
      }
      var data = {
        name: this.addName,
        pid: this.parentId
      };
      if (type === 2) {
        this.preventBlur = false;
        return;
      }
      if (type === 0) {
        this.preventBlur = false;
      }
      saveSubordinateApi(data).then(function (res) {
        _this18.tableFrom.pid = 0;
        if (res.status == 200) {
          _this18.getTableData();
        }
      });
    },
    // 失去焦点
    handleBlur: function handleBlur(row) {
      if (!this.addName.trim()) {
        this.removeRow(row);
        this.activeAdd = false;
      } else {
        this.preventBlur = true;
        this.activeAdd = false;
      }
    },
    /**
     * 移除行
     *
     * @param row 要移除的行数据
     */
    removeRow: function removeRow(row) {
      var parent;
      if (row.pid) {
        parent = this.findRow(this.tableData, row.pid);
      } else {
        parent = row;
      }
      if (parent && parent.children.length > 0) {
        // 直接移除最后一个元素
        parent.children.pop();
      }
      // if (parent) {
      //   const index = parent.children.findIndex(child => child.id === row.id);
      //   parent.children.splice(index, 1);
      // } else {
      //   const index = this.tableData.findIndex(item => item.id === row.id);
      //   this.tableData.splice(index, 1);
      // }
    },
    /**
     * 查找指定id的节点行
     *
     * @param data 数据数组
     * @param id 目标id
     * @returns 返回找到的节点行，若未找到则返回null
     */
    findRow: function findRow(data, id) {
      if (!id) {
        data.children = [];
      }
      for (var i = 0; i < data.length; i++) {
        if (data[i].id === id) {
          return data[i];
        }
        if (data[i].children && data[i].children.length) {
          var found = this.findRow(data[i].children, id);
          if (found) return found;
        }
      }
      return null;
    },
    /**
     * 提交新增行
     *
     * @param id 行的ID
     */
    submitNewRow: function submitNewRow(id) {
      var index = this.tableData.findIndex(function (item) {
        return item.id === id;
      });
      if (index !== -1) {
        this.tableData[index].edit = false;
      }
    },
    /**
     * 取消编辑
     *
     * @returns 无返回值
     */
    cancelEdit: function cancelEdit() {
      this.getTableData();
    },
    /**
     * 放置任务名称
     *
     * @param row 当前行数据
     * @param type 类型，1 表示新增，0 表示编辑
     */
    putName: function putName(row, type) {
      var _this19 = this;
      if (type === 1) {
        this.preventBlur = true;
      }
      if (type === 0) {
        this.activeEdit = false;
      }
      this.$nextTick(function () {
        if (type === 0 && _this19.preventBlur) {
          _this19.preventBlur = false;
          return;
        }
        if (row.name.trim()) {
          _this19.putProgramTask('name', row.name, row.id);
        } else {
          _this19.$message('任务名称不能为空');
        }
      });
    },
    /**
     * 编辑子节点
     *
     * @param currentId 当前节点ID
     * @returns 如果当前有编辑状态则返回false，否则设置编辑状态为true
     */
    editChild: function editChild(currentId) {
      var _this20 = this;
      if (this.activeEdit) {
        return false;
      }
      this.activeEdit = true;
      this.tableData.forEach(function (item) {
        if (item.id === currentId) {
          _this20.$set(item, 'edit', true);
        } else if (item.children) {
          item.children.forEach(function (it) {
            if (it.id === currentId) {
              _this20.$set(it, 'edit', true);
            }
          });
        }
      });
    },
    /**
     * 显示编辑版本信息
     *
     * @param row 当前行数据
     * @param index 当前行索引
     * @param type 操作类型
     * @returns 无返回值
     */
    showVersion: function showVersion(row, index, type) {
      if (!row.operate) {
        return this.$message('没有操作权限');
      }
      this.versionId = '';
      this.$set(this.adminsVisible, this.adminIndex, false);
      this.$set(this.versionVisible, this.versionIndex, false);
      this.$set(this.membersVisible, this.membersIndex, false);
      this.versionId = row.version_id || '';
      this.changeVersion(row.program_id, index, type);
    },
    /**
     * 显示编辑负责人
     *
     * @param row 当前行数据
     * @param index 当前行索引
     * @returns 无返回值
     */
    showAdmins: function showAdmins(row, index) {
      if (!row.operate) {
        return this.$message('没有操作权限');
      }
      this.adminsUid = null;
      this.$set(this.adminsVisible, this.adminIndex, false);
      this.$set(this.versionVisible, this.versionIndex, false);
      this.$set(this.membersVisible, this.membersIndex, false);
      this.adminsUid = row.uid || null;
      this.changeAdmins(row.program_id, index, 1);
    },
    /**
     * 显示编辑成员列表
     *
     * @param row 表格行数据
     * @param index 表格行索引
     * @returns 无返回值
     */
    showMembers: function showMembers(row, index) {
      var _this21 = this;
      if (!row.operate) {
        return this.$message('没有操作权限');
      }
      this.membersId = [];
      this.$set(this.adminsVisible, this.adminIndex, false);
      this.$set(this.versionVisible, this.versionIndex, false);
      this.$set(this.membersVisible, this.membersIndex, false);
      this.membersIndex = index;
      row.members.map(function (item) {
        _this21.membersId.push(item.id);
      });
      this.changeAdmins(row.program_id, index, 2);
    },
    /**
     * 隐藏版本号
     *
     * @param index 版本号索引
     */
    hideVersion: function hideVersion(index) {
      this.$set(this.versionVisible, index, false);
    },
    /**
     * 隐藏管理员
     *
     * @param index 管理员索引
     */
    hideAdmins: function hideAdmins(index) {
      this.$set(this.adminsVisible, index, false);
    },
    /**
     * 隐藏成员
     *
     * @param index 成员索引
     */
    hideMembers: function hideMembers(index) {
      this.$set(this.membersVisible, index, false);
    },
    /**
     * 视图切换搜索
     *
     * @param data 树形控件变化后的数据
     */
    treeChange: function treeChange(data) {
      this.tableFrom.types = data.value;
      this.getTableData(this.tableFrom);
    },
    /**
     * 设置数据字典
     *
     * @param field_name_en 字段名称英文标识
     * @param data_dict 数据字典
     */
    setDataDict: function setDataDict(field_name_en, data_dict) {
      for (var i = 0; i < this.search.length; i++) {
        if (this.search[i].field_name_en == field_name_en) {
          this.search[i].data_dict = data_dict;
          break;
        }
      }
    }
  }
};